<template>
  <v-dialog
    transition="dialog-bottom-transition"
    max-width="1200"
    v-model="dialog"
  >
    <template>
      <v-card v-if="device">
        <v-toolbar
          color="primary"
          dark
        >

          <v-btn
            @click="handleClose"
            style="margin-right: 20px;"
          >Cerrar</v-btn>
          <v-spacer/>
          <v-btn
            @click="onSyncDevice(device)"
            style="margin-right: 20px;"
          >
            <v-icon>mdi-sync</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text style="padding-top: 10px;">
        <v-card 
          style="margin-bottom: 5px;padding:5px 10px;"
        >
          <v-row>
            <v-col
              cols="12"
              sm="12"
              md="12"
            >
              <v-text-field
                v-bind="{ 'outlined' : true}"
                v-model="device.Name"
                label="Nombre"
                hide-details
                dense
              />
            </v-col>
            <v-col
              cols="12"
              sm="12"
              md="12"
            >
              <v-text-field
                v-bind="{ 'outlined' : true}"
                v-model="device.Description"
                label="Descripción"
                hide-details
                dense
              />
            </v-col>
            <v-col
              cols="12"
              sm="12"
              md="12"
            >
              <small>Grupo: </small>
              <v-row no-gutters v-if="device.ReportedGroupID === device.TargetGroupID">
                <v-col
                  cols="12"
                  sm="12"
                >
                  <v-alert
                    color="blue"
                  >
                    <v-autocomplete
                      v-model="device.SelectedGroupID"
                      :items="groups"
                      outlined
                      dense
                      hide-details
                      itemText="Name"
                      itemValue="ID"
                      :disabled="loading"
                    />
                  </v-alert>
                </v-col>
              </v-row>
              <v-row no-gutters v-else>
                <v-col
                  cols="12"
                  sm="5"
                >
                  <v-alert
                    color="grey"
                    style="padding: 25px 22px;"
                  >
                    {{ device.ReportedGroupName }}
                  </v-alert>
                </v-col>
                <v-col
                  cols="12"
                  sm="2"
                  style="text-align:center;padding-top:15px;"
                >
                    <v-icon>mdi-arrow-right-bold</v-icon>
                </v-col>
                <v-col
                  cols="12"
                  sm="5"
                >
                  <v-alert
                    color="green"
                  >
                    <v-autocomplete
                      v-model="device.SelectedGroupID"
                      :items="groups"
                      outlined
                      dense
                      hide-details
                      itemText="Name"
                      itemValue="ID"
                      :disabled="loadingGroups"
                      loading="loadingGroups"
                    />
                  </v-alert>
                </v-col>
              </v-row>
              <small>Presentación: </small>
                <v-row no-gutters>
                <v-col
                  cols="12"
                  sm="12"
                >
                  <v-alert
                    color="orange"
                    style="opacity: 50%;"
                  >
                    {{ device.PresentationName }} 
                  </v-alert>
                </v-col>
              </v-row>
            </v-col>
            <v-col
              cols="12"
              sm="12"
              md="4"
              style="margin: 0;"
            >
              <v-checkbox
                v-model="device.ForceReboot"
                label="Force reboot"
                hide-details
                style="margin-top: 0 !important;"
              />
            </v-col>
            <v-col
              cols="12"
              sm="12"
              md="4"
              style="margin: 0;"
            >
              <v-checkbox
                v-model="device.ForceReformat"
                label="Force reformat"
                hide-details
                style="margin-top: 0 !important;"
              />
            </v-col>
            <v-col
              cols="12"
              sm="12"
              md="4"
              style="margin: 0;"
            >
              <v-btn
                @click="handleSave"
                color="red"
                block
                dark
                :loading="loading"
              >
                Guardar
              </v-btn>
            </v-col>
            <v-col
              cols="12"
              sm="12"
              md="6"
              style="margin-top: 0;margin-bottom: 10px;"
            >
              <small>Fecha de última modificación:</small><span style="margin-left: 10px;">{{device.LastModifiedDate}}</span>
            </v-col>
          </v-row>
          <v-row no-gutters style="border-radius: 5px;background-color: #CCCCCC80;padding: 5px;">
            <v-col
              cols="12"
              sm="12"
              md="12"
              style="padding-left: 10px;"
            >
              <small>Estados de ocultación: <i style="color: red;">(se guardan automáticamente al ser seleccionadas)</i></small>
            </v-col>
            <v-col
              v-for="(item, index) of hideButtons"
              :key="`hideButton${index}`"
              cols="12"
              sm="6"
              style="padding: 5px;"
            >
              <v-btn
                block
                :color="device[item.id] === 1 ? 'grey' : 'white'"
                :dark="device[item.id] === 1 ? true : false"
                @click="handleUpdatePlayer(device, item.id)"
              >
                  <v-icon style="margin-right: 10px;">{{ device[item.id] === 1 ? 'mdi-checkbox-outline' : 'mdi-checkbox-blank-outline'}}</v-icon> {{item.name}}
              </v-btn>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col
              cols="12"
              sm="12"
              style="padding: 5px;"
            >
                {{device.ForceReboot === 1 ? '[Pendiente de Reinicio] ' : ''}}
                {{device.ForceRecovery === 1 ? '[Pendiente de Recovery] ' : ''}}
                {{device.ForceReformat === 1 ? '[Pendiente de Reformat] ' : ''}}
            </v-col>
          </v-row>
        </v-card>
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn
            text
            @click="handleClose"
          >Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </template>
  </v-dialog>
</template>
<script>
import axios from 'axios'
export default {
  props: {
    device: {
      type: Object,
      default: null,
    },
    onClose: {
      type: Function,
      required: true,
    },
    onUpdatePlayer: {
      type: Function,
      required: true,
    },
    onSyncDevice: {
      type: Function,
      required: true,
    },
  },
  data: () => ({
    dialog: false,
    errors: [],
    loading: false,
    loadingGroups: false,
    groups: [],
  }),
  computed: {
    apiURL () {
      return `${process.env.VUE_APP_ENV === 'production' ? 'https' : 'http'}://${process.env.VUE_APP_API_DVIEWCONNECT_URL}`
    },
    hideButtons () {
      return [
        { id: 'Installation', name: 'Pendiente de instalación' },
        { id: 'Closed', name: 'Temporalmente cerrado' },
        { id: 'Recovery', name: 'Recogida' },
        { id: 'Viewing', name: 'Visionado' },
        { id: 'Missing', name: 'Perdido' },
        { id: 'BackupDevice', name: 'Reserva' }
      ]
    },
    token () {
      return localStorage.getItem('jwt')
    },
  },
  watch: {
    device (v) {
      this.dialog = v ? true : false
    },
    'device.Network' () {
      this.handleGetGroups()
    },
  },
  mounted () {
    this.handleGetGroups()
  },
  methods:{
    handleGetGroups () {
      this.groups = []
      if (!this.device) return
      this.loadingGroups = true
      axios.put(`${this.apiURL}/v1/private/brightsign/${this.device.Network}/groups?token=${this.token}`, {})
        .then (response => {
          this.groups = response.data
          this.loadingGroups = false
        })
        .catch (error => {
          console.log(error)
          this.loadingGroups = false
        })
    },
    handleClose () {
      this.onClose()
    },
    handleUpdatePlayer(device, type) {
      if (type === 'Installation') {
        device.Installation = device.Installation ? false : true
        return this.onUpdatePlayer(device, type)
      }
      if (type === 'Closed') {
        device.Closed = device.Closed ? false : true
        return this.onUpdatePlayer(device, type)
      }
      if (type === 'Recovery') {
        device.Recovery = device.Recovery ? false : true
        return this.onUpdatePlayer(device, type)
      }
      if (type === 'Viewing') {
        device.Viewing = device.Viewing ? false : true
        return this.onUpdatePlayer(device, type)
      }
      if (type === 'Missing') {
        device.Missing = device.Missing ? false : true
        return this.onUpdatePlayer(device, type)
      }
      if (type === 'BackupDevice') {
        device.BackupDevice = device.BackupDevice ? false : true
        return this.onUpdatePlayer(device, type)
      }
    },
    async handleSave () {
      this.loading = true
      axios.patch(`${this.apiURL}/v1/private/brightsign/${this.device.Network}/devices/${this.device.ID}?token=${this.token}`, this.device)
        .then (() => {
          alert('Completado!!!')
          this.loading = false
        })
        .catch (error => {
          console.log(error)
          this.loading = false
        })
    },
  },
}
</script>


